import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";

import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import TextField from "@mui/material/TextField";
import ViewCCentry from "./ViewCCentry";
import { FileUpload, UploadFile } from "@mui/icons-material";
import { FileUploader } from "react-drag-drop-files";
import {
  CloudOffIcon,
  SearchIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  ReportProblemIcon,
} from "../../../Resources/Icons/icons";
import {
  GetCompany,
  GetPolicyFileById,
  GetSubBookingCode,
  GetSubProduct,
} from "../../../Service/_index";
import {
  GetFilterCCEntry,
  GetFilterCCEntryAll,
  unlinkTicketNumber,
  ReframeEndDateTimeFormat,
  uploadCCEntryData,
} from "../../../Service/SearchPolicy";
import { CSVLink } from "react-csv";
import { Dialog } from "@mui/material";
import { DatePicker } from "antd";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import { checkUserType } from "../../../Shared/CommonConstant";
import Loader from "../../../UiComponents/Loader/Loader";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Divider, Stack, Badge } from "@mui/material";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CustomButton from "../../../UiComponents/CommonBUtton/ConfirmBox";
import wallett from "../../../Resources/Images/wallet.png";
import { multiInputDateRangeFieldClasses } from "@mui/x-date-pickers-pro";

const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getClassName = (data) => {
  return data.policyNumber ? "file_link" : null;
};

const FilterCCOption = [
  {
    label: "Pending Policy",
    value: "approvePending",
    _id: "approvePending",
  },
  {
    label: "Entry Done",
    value: "entryDone",
    _id: "entryDone",
  },
  {
    label: "Already Exist",
    value: "alreadyExist",
    _id: "alreadyExist",
  },
  {
    label: "Entry Date",
    value: "entryDate",
    _id: "entryDate",
  },
  {
    label: "Approve Date",
    value: "approveDate",
    _id: "approveDate",
  },
];
const tempHeadCells = [
  {
    id: "issueDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },

  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "registrationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Reg Number",
  },
  {
    id: "product",
    placeMent: true,
    disablePadding: false,
    label: "Product",
  },
  {
    id: "subProduct",
    placeMent: true,
    disablePadding: false,
    label: "SubProduct",
  },
  {
    id: "totalPremium",
    placeMent: true,
    disablePadding: false,
    label: "Total Premium",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "User Email",
  },
  {
    id: "ticketNumber",
    placeMent: true,
    disablePadding: false,
    label: "Ticket Number",
  },
  {
    id: "ticketStatus",
    placeMent: true,
    disablePadding: false,
    label: "Ticket Status",
  },
  {
    id: "action",
    placeMent: true,
    disablePadding: false,
    label: "Action",
  },
];

// Added by Arun
const headCells =
  sessionStorage.getItem("userType") == "SUBCODE"
    ? tempHeadCells?.filter((e) => e.label !== "User Email")
    : tempHeadCells;

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
            style={{ minWidth: headCells.minWidth }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const CCEntry = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [policyList, setPolicyList] = React.useState([]);
  const [excelList, setExcelList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [selectedBookingCode, setSelectedBookingCode] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [policyNumber, setPolicyNumber] = useState("");
  const [selectedSubBookingCode, setSelectedSubBookingCode] = useState(null);
  const [openViewCC, setOpenViewCC] = useState(false);
  const [resetValue, setResetValue] = useState(1);
  const [selectedData, setSelectedData] = useState({});
  const [edit, setEdit] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedEndtDate, setSelectedEndDate] = useState();
  const [openLoader, setOpenLoader] = useState(false);
  const [filterBy, setFilterBy] = useState({});
  const [openConfirmBox, setOpenConfirmBox] = useState(false);
  const [approvePending, setApprovePending] = useState(false);
  const [filteredCells, setFilteredCells] = useState(headCells);
  const [ccEntryFile, setCCEntryFile] = useState(null);
  const [status, setStatus] = useState("");
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const csvLinkRef = React.useRef(null);
  const [resetFileKey, setResetFileKey] = useState(1);

  //const [showFilter, setShowFilter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    // isAction: true,
    isView: true,
    isEdit: true,
  });
  const [dateRange, setDateRange] = useState([]);

  const downloadExcel = async () => {
    // await apiCallForDownloadExcel();
    console.log("csvLinkRef.current.link : ", csvLinkRef.current.link);
    console.log("header ", csvFile.headers);
    if (csvLinkRef.current) {
      csvLinkRef.current.link.click(); // Trigger the CSV download
    }
  };
  // For pagination
  const [count, setCount] = useState(0);
  const [totalPremium, setTotalPremium] = useState(0);
  const defaultQueryParams = {
    page: 0,
    limit: 10,
    search: "",
    skip: 0,
    sort: "",
    isDownloadExcel: false,
  };
  const [queryParam, setQueryParam] = useState(defaultQueryParams);
  const [isInitialized, setIsInitialized] = useState(false);

  // const visibleRows = React.useMemo(
  //   () =>
  //     stableSort(filter.fn(FilteredData), getComparator(order, orderBy))?.slice(
  //       page * rowsPerPage,
  //       page * rowsPerPage + rowsPerPage
  //     ),
  //   [order, orderBy, page, rowsPerPage, filter, FilteredData]
  // );

  // Added by Arun
  const resetQueryParams = () => {
    setQueryParam(defaultQueryParams);
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    console.log("newPage ", newPage);
    setQueryParam({
      ...queryParam,
      page: newPage,
      skip: newPage * rowsPerPage,
    });
    setPage(newPage);
  };
  const uploadExcel = async () => {
    // console.log("csvLinkRef.current.link : ", ccEntryFile);
    if (!ccEntryFile) {
      ToastError("Please upload cc entry excel data");
      return true;
    }
    let formData = new FormData();
    formData.append(ccEntryFile, ccEntryFile);
    setOpenLoader(true);
    await uploadCCEntryData(formData)
      .then((res) => {
        if (res?.message) {
          ToastSuccess(res.message);
          setCCEntryFile(null);
        }
        // UniversalSearch(true);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setQueryParam({ ...queryParam, limit: event.target.value, page: 0 });
    setPage(0);
  };

  const onSearch = (e) => {
    let target = e.target.value;
    setQueryParam({
      ...queryParam,
      search: target,
    });
    // setFilter({
    //   fn: (items) => {
    //     if (target.value == "") return items;
    //     else
    //       return items.filter((el) =>
    //         `${el?.companyId?.companyName},${el.policyNumber},${
    //           el.customerName
    //         },${el.registrationNumber},${el.odPremium},${el.netPremium},${
    //           el.totalPremium
    //         },${el?.userId?.email},${el.ticketNumber},${moment(
    //           el.issueDate
    //         ).format("D-M-Y")}`
    //           .toLowerCase()
    //           .includes(target.value.toLowerCase())
    //       );
    //   },
    // });
    // setPage(0);
  };

  const FilteredData = policyList?.filter((el) => {
    const searchTerm = searchText.toLowerCase();
    const policyListDetails =
      `${el?.companyName},${el?.paymentMode},${el?.email},${el?.customerName},${el?.registrationNumber},${el?.policyNumber}`.toLowerCase();
    return policyListDetails.includes(searchTerm);
  });
  console.log("FilteredData", FilteredData);
  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompany = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompany);
    });
  };

  const GetSubBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: "combineData" }).then((res) => {
      const SubBookingCodeDetails = res.data
        .map((e) => {
          if (e.isEnabled && e.cc === "Yes") {
            return {
              ...e,
              label: e.bookingCode + " - " + e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setSubBookingCodeDetails(SubBookingCodeDetails);
    });
  };
  const [productData, setProductData] = useState([]);
  const GetProductDetails = () => {
    GetSubProduct({ isAscending: "combineData" }).then((res) => {
      const subProductDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: `${e?.product} - ${e?.subProduct}`,
              value: e?._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      setProductData(subProductDetails);
    });
  };

  const UniversalSearch = async (isFirstPage) => {
    // if (filterBy?.bookingCodeId && filterBy?.subBookingCodeId) {
    if (selectedBookingCode) {
      setOpenLoader(true);
      // Changes by Arun
      // let endDate = null;
      // if (selectedEndtDate) {
      //   endDate = await ReframeEndDateTimeFormat(selectedEndtDate);
      // }
      // For pagination
      // if (isFirstPage) {
      //   queryParam["page"] = 1;
      // }

      console.log("dateRange", dateRange);
      const selectedStartDate = dateRange[0];
      const selectedEndDate = dateRange[1];
      console.log("selectedEndDate", selectedEndDate, selectedStartDate);

      // Build filter payload directly from current state to ensure latest values
      // const subBookingCodeIds = extractIds(selectedBookingCode);
      // const companyIds = extractIds(selectedCompany);
      const subBookingCodeIds = selectedBookingCode
        .map((item) =>
          typeof item === "object" ? item.value || item._id : item
        )
        .filter(Boolean);
      const companyIds = selectedCompany
        .map((item) =>
          typeof item === "object" ? item.value || item._id : item
        )
        .filter(Boolean);

      // Build the request payload
      const requestPayload = {
        ...(subBookingCodeIds && { subBookingCodeId: subBookingCodeIds }),
        ...(companyIds && { companyId: companyIds }),
        ...(selectedStatus && { status: selectedStatus }),
        ...(policyNumber && { policyNumber: policyNumber }),
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        // For pagination
        page: queryParam.page,
        limit: queryParam.limit,
        search: queryParam.search,
        sort: queryParam.sort,
        isDownloadExcel: queryParam.isDownloadExcel,
      };

      await GetFilterCCEntry(requestPayload).then((res) => {
        setOpenLoader(false);
        const FilteredData = res?.data?.tableData.map((e) => {
          return {
            ...e,
            issueDate: e.issueDate
              ? moment(e.issueDate).format("DD/MM/YYYY")
              : e.issueDate,
            InformatDate: moment(e.issueDate).format("DD/MM/YYYY"),
          };
        });
        if (!queryParam.isDownloadExcel) {
          setPolicyList(FilteredData);
        }
        setExcelList(FilteredData);
        setCount(res?.data?.totalRecords);
        setTotalPremium(res?.data?.totalPremium);
        // For pagination
        if (isFirstPage) {
          setPage(0);
        }
      });
    } else {
      setPolicyList([]);
      setExcelList([]);
      ToastError("Booking code and SubBooking code required!!");
    }
  };

  const apiCallForDownloadExcel = async () => {
    // if (filterBy?.bookingCodeId && filterBy?.subBookingCodeId)
    if (selectedBookingCode && selectedSubBookingCode) {
      setOpenLoader(true);
      // Changes by Arun
      // let endDate = null;
      // if (selectedEndtDate) {
      //   endDate = await ReframeEndDateTimeFormat(selectedEndtDate);
      // }

      const selectedStartDate = dateRange[0];
      const selectedEndDate = dateRange[1];

      // Build filter payload directly from current state to ensure latest values
      const subBookingCodeIds = extractIds(selectedBookingCode);
      const companyIds = extractIds(selectedCompany);

      // Build the request payload
      const requestPayload = {
        ...(subBookingCodeIds && { subBookingCodeId: subBookingCodeIds }),
        ...(companyIds && { companyId: companyIds }),
        ...(selectedStatus && { status: selectedStatus }),
        ...(policyNumber && { policyNumber: policyNumber }),
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        // For pagination
        isDownloadExcel: true,
      };

      await GetFilterCCEntry(requestPayload).then((res) => {
        setOpenLoader(false);
        const FilteredData = res?.data?.tableData.map((e) => {
          return {
            ...e,
            issueDate: e.issueDate
              ? moment(e.issueDate).format("DD/MM/YYYY")
              : e.issueDate,
            InformatDate: moment(e.issueDate).format("DD/MM/YYYY"),
          };
        });
        let wb = new ExcelJS.Workbook();
        let workbookName = `CC Entry Data ${new Date()}.xlsx`;
        let worksheetName = "CC Entry";
        let ws = wb.addWorksheet(worksheetName, {
          properties: {
            tabColor: { argb: "FFFF0000" },
          },
        });

        ws.columns = header;
        // console.log("FormatedData  ", FormatedData);
        ws.addRows(FilteredData);

        ws.eachRow((row, rowNumber) => {
          row.eachCell({ includeEmpty: true }, (cell) => {
            // Set default border style for all cells (including empty cells)
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });

        wb.xlsx.writeBuffer().then(function (buffer) {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            workbookName
          );
        });
      });
    } else {
      setPolicyList([]);
      setExcelList([]);
      ToastError("Booking code and SubBooking code required!!");
    }
  };
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/cc-entry-sample-data.xlsx"; // Path in the public folder
    link.download = "cc-entry-sample-data.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleButton = (row) => {
    CCEntryFunction(row);
    setEdit("ccEntry");
  };

  const CCEntryFunction = (row) => {
    setOpenLoader(true);
    setOpenViewCC(true);
    setSelectedData(row);
    // setOpenLoader(false)
  };

  const DeleteCCdata = async (row) => {
    setOpenConfirmBox(true);
    setSelectedData(row);
  };

  const DeleteFunction = () => {
    unlinkTicketNumber(selectedData._id).then((res) => {
      UniversalSearch(true);
      setOpenConfirmBox(false);
    });
  };

  // let totalPremium = 0;
  // policyList?.map((row) => {
  //   const premiumWithoutCommas = row?.totalPremium.replace(/,/g, "");
  //   let totPremium = parseFloat(premiumWithoutCommas);
  //   totalPremium += totPremium;
  // });

  const header = [
    { header: "Policy Date", key: "InformatDate" },
    { header: "Company Name", key: "company" },
    { header: "Policy Number", key: "policyNumber" },
    { header: "Reg Number", key: "registrationNumber" },
    { header: "Product", key: "product" },
    { header: "SubProduct", key: "subProduct" },
    { header: "Total Premium", key: "totalPremium" },
    { header: "User Email", key: "email" },
    { header: "Ticket Number", key: "ticketNumber" },
  ];

  const csvFile = {
    filename: "CC Entry Data",
    headers: header,
    data: excelList,
  };

  React.useEffect(() => {
    GetCompanyDetails();
    GetSubBookingCodeDetails();
    GetProductDetails();
  }, []);

  const UserType = sessionStorage.getItem("userType");

  const [isAllow, setIsAllow] = useState({});
  React.useEffect(() => {
    const isallowObj = checkUserType(UserType);
    setIsAllow(isallowObj);
  }, []);

  React.useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
      return;
    } else {
      UniversalSearch(false);
    }
  }, [queryParam.page, queryParam.limit, queryParam.search, queryParam.sort]);

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(`<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`);
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const formatNumber = (num) => new Intl.NumberFormat("en-IN").format(num);

  // Helper function to extract IDs from array (handles both string IDs and objects)
  const extractIds = (items) => {
    if (!items) return null;
    if (Array.isArray(items)) {
      if (items.length === 0) return null;
      return items.map((item) => {
        if (typeof item === "string") return item;
        return item._id || item.value || item;
      });
    }
    // Handle single value
    if (typeof items === "string") {
      return items.trim() === "" ? null : items;
    }
    return items._id || items.value || items;
  };

  const handleClearAllState = () => {
    setSelectedBookingCode([]);
    setSelectedSubBookingCode(null);
    setSelectedCompany([]);
    setSelectedStatus(null);
    setPolicyNumber(null);
    setDateRange([]);
    // Clear the policy list since booking code is required for fetching data
    setPolicyList([]);
    setExcelList([]);
    setCount(0);
    setTotalPremium(0);
  };

  const handleClearSingleFilter = async (filterId) => {
    // Check if booking code is selected before clearing (required for API call)
    const hasBookingCode =
      selectedBookingCode && selectedBookingCode.length > 0;

    if (!hasBookingCode && filterId !== 1) {
      // Can't fetch without booking code
      return;
    }

    // Prepare cleared values based on filter ID
    let clearedCompany = selectedCompany;
    let clearedDateRange = dateRange;
    let clearedStatus = selectedStatus;
    let clearedPolicyNumber = policyNumber;
    let clearedBookingCode = selectedBookingCode;

    // Clear the specific filter based on ID
    if (filterId === 1) {
      // Clear Booking Code
      setSelectedBookingCode([]);
      setSelectedSubBookingCode(null);
      clearedBookingCode = [];
      // Can't fetch without booking code, so don't call API
      return;
    } else if (filterId === 2) {
      // Clear Company
      setSelectedCompany([]);
      clearedCompany = [];
    } else if (filterId === 3) {
      // Clear Date
      setDateRange([]);
      clearedDateRange = [];
    } else if (filterId === 4) {
      // Clear Status/Filter
      setSelectedStatus(null);
      clearedStatus = null;
    } else if (filterId === 5) {
      // Clear Policy Number
      setPolicyNumber(null);
      clearedPolicyNumber = null;
    }

    // Build payload with cleared values to ensure they're not included
    const subBookingCodeIds = extractIds(clearedBookingCode);
    const companyIds = extractIds(clearedCompany);
    const selectedStartDate = clearedDateRange?.[0];
    const selectedEndDate = clearedDateRange?.[1];

    // Build the request payload with cleared values
    const requestPayload = {
      ...(subBookingCodeIds && { subBookingCodeId: subBookingCodeIds }),
      ...(companyIds && { companyId: companyIds }),
      ...(clearedStatus && { status: clearedStatus }),
      ...(clearedPolicyNumber && { policyNumber: clearedPolicyNumber }),
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      // For pagination
      page: queryParam.page,
      limit: queryParam.limit,
      search: queryParam.search,
      sort: queryParam.sort,
      isDownloadExcel: queryParam.isDownloadExcel,
    };

    // Fetch data with cleared filter values
    setOpenLoader(true);
    try {
      const res = await GetFilterCCEntry(requestPayload);
      setOpenLoader(false);
      const FilteredData = res?.data?.tableData.map((e) => {
        return {
          ...e,
          issueDate: e.issueDate
            ? moment(e.issueDate).format("DD/MM/YYYY")
            : e.issueDate,
          InformatDate: moment(e.issueDate).format("DD/MM/YYYY"),
        };
      });
      if (!queryParam.isDownloadExcel) {
        setPolicyList(FilteredData);
      }
      setExcelList(FilteredData);
      setCount(res?.data?.totalRecords);
      setTotalPremium(res?.data?.totalPremium);
      setPage(0);
    } catch (error) {
      setOpenLoader(false);
      console.error("Error filtering CC Entry:", error);
      ToastError("Failed to filter data. Please try again.");
    }
  };

  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleSaveAllFilter = () => {
    if (!selectedBookingCode || selectedBookingCode.length === 0) {
      ToastError("Please select a Booking Code before applying filters!");
      return;
    }
    if (status === "approvePending" || status === "alreadyExist") {
      setFilteredCells(headCells);
    } else if (status === "entryDone" || status === "entryDate") {
      setFilteredCells(headCells.filter((e) => e.id !== "action"));
      setTableConfig({
        isAction: true,
        isView: true,
        isEdit: true,
        isDelete: true,
      });
    }
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (searchTrigger > 0) {
      UniversalSearch();
    }
  }, [searchTrigger]);

  useEffect(() => {
    if (selectedBookingCode && selectedBookingCode.length > 0) {
      if (
        selectedStatus === "approvePending" ||
        selectedStatus === "alreadyExist"
      ) {
        setFilteredCells(headCells);
      } else if (
        selectedStatus === "entryDone" ||
        selectedStatus === "entryDate"
      ) {
        setFilteredCells(headCells.filter((e) => e.id !== "action"));
        setTableConfig({
          isAction: true,
          isView: true,
          isEdit: true,
          isDelete: true,
        });
      }
      setSearchTrigger((prev) => prev + 1);
    }
  }, [
    selectedBookingCode,
    selectedCompany,
    selectedStatus,
    policyNumber,
    dateRange,
  ]);

  useEffect(() => {
    if (!selectedBookingCode || selectedBookingCode.length === 0) {
      setFilterBy((prev) => {
        const updated = { ...prev };
        delete updated.subBookingCodeId;
        delete updated.bookingCodeId;
        return updated;
      });
      return;
    }

    // Extract subBookingCodeId from array
    const subBookingCodeIds = extractIds(selectedBookingCode);

    // Get bookingCodeId from the first selected sub booking code
    const firstSubBookingCode = Array.isArray(selectedBookingCode)
      ? selectedBookingCode[0]
      : selectedBookingCode;
    const subBookingCodeItem = subBookingCodeDetails?.find(
      (item) =>
        item._id === firstSubBookingCode || item.value === firstSubBookingCode
    );
    const bookingCodeId = subBookingCodeItem?.bookingCodeId;

    setSelectedSubBookingCode(bookingCodeId);
    setFilterBy((prev) => ({
      ...prev,
      subBookingCodeId: subBookingCodeIds,
      ...(bookingCodeId && { bookingCodeId: bookingCodeId }),
    }));
  }, [selectedBookingCode, subBookingCodeDetails]);

  useEffect(() => {
    setStatus(selectedStatus);
  }, [selectedStatus]);

  useEffect(() => {
    if (!selectedCompany || selectedCompany.length === 0) {
      setFilterBy((prev) => {
        const updated = { ...prev };
        delete updated.companyId;
        return updated;
      });
      return;
    }

    // Extract companyId from array
    const companyIds = extractIds(selectedCompany);

    setFilterBy((prev) => ({
      ...prev,
      companyId: companyIds,
    }));
  }, [selectedCompany]);

  useEffect(() => {
    if (!selectedStatus) {
      setFilterBy((prev) => {
        const updated = { ...prev };
        delete updated.status;
        return updated;
      });
      return;
    }

    setFilterBy((prev) => ({
      ...prev,
      status: selectedStatus,
    }));
  }, [selectedStatus]);

  const filterBoxData = [
    {
      id: 1,
      label: "Select Booking and Sub Booking Code",
      data: subBookingCodeDetails,
      setState: setSelectedBookingCode,
      value: selectedBookingCode,
      type: "input",
      variation: "multiple",
      multiple: true,
    },
    {
      id: 2,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedCompany,
      type: "input",
      variation: "multiple",
      multiple: true,
    },
    {
      id: 3,
      label: "Select Date",
      setDate: (range) => {
        setDateRange(range);
        setSearchTrigger((prev) => prev + 1);
      },
      value: dateRange,
      type: "noDefaultDate",
    },
    {
      id: 4,
      label: "Filter",
      data: FilterCCOption,
      // setState: (e) => {
      //   console.log("e", e?._id);
      //   let option = FilterCCOption.find((el) => el._id === e);
      //   setSelectedStatus(option.value);
      // },
      // value: FilterCCOption.find(opt => opt.value === selectedStatus)?._id,
      setState: setSelectedStatus,
      value: selectedStatus,
      type: "input",
      variation: "single",
    },
    {
      id: 5,
      label: "Policy Number",
      setState: setPolicyNumber,
      value: policyNumber,
      type: "normalInput",
    },
  ];

  const [showFilter, setShowFilter] = useState(true);

  const activeFiltersCount = [
    selectedBookingCode?.length > 0 ? 1 : 0,
    selectedCompany?.length > 0 ? 1 : 0,
    dateRange?.length > 0 ? 1 : 0,
    selectedStatus,
    policyNumber,
  ].filter(Boolean).length;

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    CC Entry
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >

                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                    sx={{ width: "100%", justifyContent: "flex-end" }}
                  >
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{ width: "102px", height: "35px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      Filters
                    </Button>
                    <Box sx={{ height: "35px", "& > label": { height: "100%" }, minWidth: "150px" }}>
                      <FileUploader
                        handleChange={(e) => {
                          // console.log("e", e);
                          setCCEntryFile(e);
                        }}
                        fileOrFiles={ccEntryFile}
                        name="CCentryFile"
                        label="Upload Excel"
                        dropMessageStyle={{
                          color: "red",
                          border: "none",
                          borderRadius: "0px",
                        }}
                        types={["XLSX", "XLS"]}
                        key={resetFileKey}
                      />
                    </Box>
                    <Button
                      className="Master_Header_create_Button"
                      onClick={() => {
                        uploadExcel();
                      }}
                      endIcon={<FileUpload />}
                      sx={{
                        height: "35px !important",
                        backgroundColor: "#1E3A5F",
                        color: "#fff",
                        gap: 2,
                        minWidth: "150px",
                        "&:hover": {
                          backgroundColor: "#0056CC",
                        },
                      }}
                    >
                      Import Data
                    </Button>
                    <Button
                      className="Master_Header_create_Button"
                      onClick={() => {
                        handleDownload();
                      }}
                      endIcon={<DownloadIcon />}
                      sx={{
                        height: "35px !important",
                        backgroundColor: "#1E3A5F",
                        color: "#fff",
                        gap: 2,
                        minWidth: "150px",
                        "&:hover": {
                          backgroundColor: "#0056CC",
                        },
                      }}
                    >
                      Sample Data
                    </Button>
                  </Stack>
                  {/* <Grid item xs={12} sm={6} /> */}
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )}
              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>

              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{ margin: "0px 10px" }}
              // className="Master_Card_Sub_Container"
              >
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={3.1}
                  mt={{ xs: 2, sm: 0, md: 0 }}
                  sx={{ display: "flex" }}
                >
                  <Grid
                    item
                    marginLeft={2}
                    margin={1}
                    sx={{
                      backgroundColor: "#F0F5FA",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      padding: "2px",
                      paddingRight: "15px",
                      paddingLeft: "15px",
                      gap: "10px",
                      border: "1px solid #DFE7F1",
                    }}
                  >
                    <Grid>
                      <img src={wallett} width="18px" height="17px" />
                    </Grid>
                    <Grid>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "500",
                          color: "#1E3A5F",
                          fontSize: 16,
                          lineHeight: "1.2",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {count ? formatNumber(count) : 0}{" "}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "500",
                          color: "#667085",
                          fontSize: 12,
                          lineHeight: "1.2",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        Policy Count{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    marginLeft={2}
                    margin={1}
                    sx={{
                      backgroundColor: "#F0F5FA",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      padding: "2px",
                      paddingRight: "15px",
                      paddingLeft: "15px",
                      gap: "10px",
                      border: "1px solid #DFE7F1",
                    }}
                  >
                    <Grid>
                      <img src={wallett} width="18px" height="17px" />
                    </Grid>
                    <Grid>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "500",
                          color: "#1E3A5F",
                          fontSize: 16,
                          lineHeight: "1.2",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {/* ₹ {calculateSum(policyCount)}{" "} */}₹{" "}
                        {/* {formatNumber(sum)} */}
                        {totalPremium ? formatNumber(totalPremium) : 0}{" "}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "500",
                          color: "#667085",
                          fontSize: 12,
                          lineHeight: "1.2",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        Total Premium
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={onSearch}
                    // onChange={(e) => {
                    //   onSearch(e.target.value);
                    // }}
                    disableUnderline={true}
                    placeholder="Search in Access"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={FilteredData}
                columns={filteredCells}
                handleOnClickBehaviour={OpenPolicyFile}
                handleButton={handleButton}
                handleEdit={(row) => {
                  CCEntryFunction(row);
                  setEdit("edit");
                }}
                handleView={() => {
                  CCEntryFunction();
                  setEdit(null);
                }}
                handleDelete={DeleteCCdata}
                isServerSide={true}
                tableTotalCount={count}
                loading={openLoader}
                // limit={rowsPerPage}
                tableOutputEvent={(params) => {
                  setQueryParam({
                    page: params.page,
                    limit: params.limit,
                    sort: params.sort,
                    search: queryParam.search,
                  });
                }}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      {edit === "ccEntry" ? (
        <Drawer
          open={openViewCC}
          sx={{
            zIndex: 100,
          }}
          anchor="right"
          PaperProps={{
            sx: { width: { xs: "100%", sm: "100%" } },
          }}
        >
          <ViewCCentry
            edit={edit}
            selectedData={selectedData}
            queryParam={queryParam}
            setOpenViewCC={setOpenViewCC}
            setPolicyList={setPolicyList}
            setCount={setCount}
            setTotalPremium={setTotalPremium}
            filterBy={filterBy}
            loader={setOpenLoader}
          />
        </Drawer>
      ) : (
        <Dialog open={openViewCC}>
          <ViewCCentry
            edit={edit}
            selectedData={selectedData}
            setOpenViewCC={setOpenViewCC}
            setPolicyList={setPolicyList}
            filterBy={filterBy}
            loader={setOpenLoader}
          />
        </Dialog>
      )}
      <ConfirmBox
        open={openConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color="error"
      />
      {/* <Loader open={openLoader} /> */}

      {useEffect(() => {
        if (!openViewCC) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, [openViewCC])}
    </>
  );
};
export default CCEntry;
